/* Обёртки без коробки: пузыри остаются элементами ленты (её `gap` и `align-self`), а в DOM есть
   корень очереди и ключ сообщения — по ним `outbox-shown.ts` решает, видна ли строка отказа. */
.contents {
  display: contents;
}

/* Вне потока ленты: `absolute` не берёт её `gap`. */
.srOnly {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
